exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---3D3Q2 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .component---3D3Q2 .title---ZqjVG {\n    width: 90%;\n    padding-top: 3px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3D3Q2",
	"title": "title---ZqjVG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/strength-weakness-topic/strength-weakness-topic.scss
// module id = bDco
// module chunks = 1